<template>
    <div class="hidden max-lg:flex max-lg:z-50">
        <div @click="toggleBurger" class="burger max-lg:!block" :class="{ 'active': this.burgerState }">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
        </div>
    </div>
    <div class="w-72 bg-black hidden max-lg:hidden max-lg:min-h-screen max-md:px-5 max-lg:px-12 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-40"
        :class="{ 'max-lg:!block': burgerState }">
        <ul class="mt-20 flex flex-col">
            <template v-if="$store.authStatus === false">
                <li>
                    <span @click="profileAction"  class="text-xl mt-5 flex gap-1 items-center cursor-pointer">
                        <p
                            class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                            {{ $t('nav.login') }}</p>
                    </span>
                </li>
            </template>
            <template v-else>
                <li>
                    <button
                        class="text-red-500 font-semibold text-xl mt-5 flex gap-1 items-center"
                        @click="logout">
                        <span class="hidden md:inline">{{ $t('action.logout') }}</span>
                        <span class="inline md:hidden">{{ $t('action.logout') }}</span>
                    </button>
                </li>
            </template>
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'publicationLiked' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                            {{ $t('nav.publicationLiked') }}</p>
                </router-link>
            </li>
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'mallLiked' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.mallLiked') }}</p>
                </router-link>
            </li>
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'mediaLiked' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.mediaLiked') }}</p>
                </router-link>
            </li>
            <!-- <li>
                <router-link @click="toggleBurger" :to="{ name: 'newsLiked' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.newsLiked') }}</p>
                </router-link>
            </li> -->
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'selectCategory' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.addPublication') }}</p>
                </router-link>
            </li>
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'myPublications' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.myPublications') }}</p>
                </router-link>
            </li> <li>
                <router-link @click="toggleBurger" :to="{ name: 'mallOrders' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.mallOrders') }}</p>
                </router-link>
            </li><li>
                <router-link @click="toggleBurger" :to="{ name: 'foodOrders' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 hover:text-app-green">
                        {{ $t('nav.foodOrders') }}</p>
                </router-link>
            </li>
            <li>
                <router-link @click="toggleBurger" :to="{ name: 'comments' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 capitalise hover:text-app-green">
                        {{ $t('nav.comments') }}</p>
                </router-link>
            </li><li>
                <router-link @click="toggleBurger" :to="{ name: 'payments' }"
                    class="text-xl mt-5 flex gap-1 items-center">
                    <p
                        class="text-white font-semibold whitespace-nowrap ease-linear transition-all duration-100 capitalise hover:text-app-green">
                        {{ $t('nav.payments') }}</p>
                </router-link>
            </li>

            

        </ul>
    </div>
    <div @click="toggleBurger"
        class="fixed top-0 left-0 min-h-screen w-full z-30 hidden bg-app-black-highlight opacity-50"
        :class="{ 'max-lg:!flex': burgerState }">

    </div>
</template>


<script>

export default {
    name: 'MallHeader',
    components: {

    },
    data(){
        return {
            burgerState: false
        }
    },
    methods: {
        profileAction() {
            this.toggleBurger()
            if (this.$store.authStatus) {
                this.$router.push({ name: 'mallOrders' })
            }
            else {
                this.$store.setState('loginModal', true)
                // this.showModal = true
            }
            
        },
        toggleBurger() {
            this.burgerState = !this.burgerState
            if (this.burgerState === true){
                document.body.style.overflow = 'hidden'
            }
            else{
                document.body.style.overflow = 'auto'
            }
            this.$emit('toggleBurger', this.burgerState)
        },
        async logout() {
            this.$store.logoutUser()
            this.$store.deleteOrderSessionId()
            this.$store.deleteFoodOrderSessionId()

            this.$router.push('/')

        },
    },
    computed: {
       
    },
    created(){

    }
}
</script>


<style >
.burger {
    width: 24px;
    height: 18px;
    position: relative;
    cursor: pointer;
    display: none;
}

.line {
    display: block;
    width: 100%;
    height: 2px;
    position: absolute;
    background-color: #212135;

}

.line:nth-child(1) {
    width: 24px;
    top: 0px;
    transition: 0.3s;
}

.line:nth-child(2) {
    width: 16px;
    top: calc(50% - 1px);
    transition: 0.3s;
}

.line:nth-child(3) {
    width: 24px;
    top: calc(100% - 2px);
}

.burger.active .line:nth-child(1) {
    transform: rotate(45deg);
    top: 8px;
    transition: 0.3s;
    background-color: white;
}

.burger.active .line:nth-child(2) {
    width: 24px;

    transform: rotate(-45deg);
    transition: 0.3s;
    background-color: white;

}

.burger.active .line:nth-child(3) {
    display: none;
}</style>